"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const luxon_1 = require("luxon");
const Box_1 = __importDefault(require("@mui/material/Box"));
const FileCopyOutlined_1 = __importDefault(require("@mui/icons-material/FileCopyOutlined"));
const notificationsUtils_1 = require("data/notifications/notificationsUtils");
const VersionDisplay = () => {
    var _a;
    const [state, setState] = React.useState({
        showVersion: false,
    });
    const date = luxon_1.DateTime.fromRFC2822((_a = process.env.COMMIT_TIME) !== null && _a !== void 0 ? _a : '').toLocaleString(luxon_1.DateTime.DATETIME_SHORT);
    const version = `Version: ${process.env.APP_VERSION} (${process.env.BUILD_NUMBER}/${process.env.COMMIT} - ${date})`;
    const downHandler = (e) => {
        if (e.altKey) { // can't use 'control' key because of MAC's control + click
            setState({ showVersion: true });
        }
    };
    const upHandler = () => {
        setState({ showVersion: false });
    };
    React.useEffect(() => {
        window.addEventListener('keydown', downHandler);
        window.addEventListener('keyup', upHandler);
        return () => {
            window.removeEventListener('keydown', downHandler);
            window.removeEventListener('keyup', upHandler);
        };
    }, []);
    return (state.showVersion ?
        <Box_1.default position="fixed" right={0} bottom={0} p={1} color="black" zIndex="13000" onClick={() => {
                var _a;
                (_a = navigator === null || navigator === void 0 ? void 0 : navigator.clipboard) === null || _a === void 0 ? void 0 : _a.writeText(version);
                (0, notificationsUtils_1.dispatchSimpleNotification)('Version copied to clipboard');
            }}>
      {version}
      &nbsp;<FileCopyOutlined_1.default fontSize="inherit"/>
    </Box_1.default>
        :
            null);
};
exports.default = VersionDisplay;
